class GestionPlatoService {
  constructor() {}
  resources = () => ({
    platos: {
      uri: `/v1/unidadcomedor/plato`,
      method: ['get']
    },
    plato: {
      uri: `/v1/unidadcomedor/plato`,
      method: ['post']
    },
    estado: {
      uri: `/v1/unidadcomedor/plato/cambiarestado`,
      method: ['put']
    }
  });
}

export default GestionPlatoService;
